import React from "react";
import Image from "next/image";

import { Typography } from "./Typography";
import Link from "next/link";

export type SectionHeadingProps = {
  iconBgColor?: string;
  title: string;
  showLogo?: boolean;
  icon?: "light" | "dark";
  titleColor?: string;
  link?: string;
  className?: string;
  customIcon?: string;
  wrapperClassName?: string;
};

const SectionHeader = ({
  title,
  titleColor,
  link,
  className,
  customIcon,
  wrapperClassName,
}: SectionHeadingProps) => {
  return (
    <div className={`flex items-center justify-start gap-1.5 ${wrapperClassName ?? "w-max"}`}>
      {/* {showLogo && (
        <div
          className="relative h-[28px] w-[28px] rounded-md overflow-hidden "
          style={{ backgroundColor: iconBgColor }}
        >
          <img
            src={icon === "light" ? "/logo-symbol.svg" : "/logo-symbol-black.svg"}
            alt="section"
            className="w-full h-full p-1 object-fit"
            loading="lazy"
          />
        </div>
      )} */}
      <div className="relative w-[35px] h-[47px] flex-shrink-0 flex items-center justify-center">
        <Image
          src={customIcon || "/icons/CarouselIcon.svg"}
          alt=""
          width={35}
          height={47}
          className="w-full h-full object-contain"
        />
      </div>
      {link ? (
        <Link href={link}>
          <Typography
            variant="h4"
            color={titleColor}
            className={`text-lg md:text-xl lg:text-2xl ${className || ""}`}
          >
            {title}
          </Typography>
        </Link>
      ) : (
        <Typography
          variant="h4"
          color={titleColor}
          className={`text-lg md:text-xl lg:text-2xl ${className || ""}`}
        >
          {title}
        </Typography>
      )}
    </div>
  );
};

export default SectionHeader;
